import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import { useCommonContext } from 'src/contexts/CommonContext';
import { ConfigContext } from '../../../contexts/ConfigContext';
import useWindowSize from '../../../hooks/useWindowSize';
import NavContent from './NavContent';
import NavLogo from './NavLogo';
import useMenuItems from './useNewMenuItems';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';

import navigation from '../../../new-menu-items';
import { ReactComponent as HectorLogo } from 'src/assets/images/common/logo-new.svg';
import { ReactComponent as HectorLogoFull } from 'src/assets/images/new-logo-contact.svg';
import { ReactComponent as LockIcon } from 'src/assets/images/common/circle_lock.svg';
import { ReactComponent as UnlockIcon } from 'src/assets/images/common/circle_unlock.svg';
import betaIconPng from 'src/assets/images/beta-icon.png';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { ThemeContext } from 'src/providers/themeProvider';
import { getNewPayloadDateRange, usePayloadContext } from 'src/contexts/PayloadContext';

const Navigation = ({ IsFlipkartUser = 0, isTrail = false }) => {
  const history = useHistory()
  const location = useLocation();

  const configContext = useContext(ConfigContext);
  const {
    layout,
    layoutType,
    navFixedLayout,
    collapseMenu,
    rtlLayout,
    boxLayout,
    subLayout,
    navBackColor,
    navDropdownIcon,
    navBrandColor,
    navListIcon,
    navActiveListColor,
    navListTitleColor,
    navBackImage,
    navIconColor,
    navListTitleHide,
    layout6Background,
    layout6BackSize
  } = configContext.state;
  const windowSize = useWindowSize();

  const { commonState, commonDispatch } = useCommonContext();
  const [collapsed, setCollapsed] = useState(true);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const theme = useContext(ThemeContext);
  
  // Use shared sidebar state from context for mobile/tablet
  const isMobileOrTablet = windowSize.width < 992;
  const sidebarCollapsed = isMobileOrTablet ? commonState.sidebarCollapsed : collapsed;
  
  const handleSidebarToggle = (value) => {
    if (isMobileOrTablet) {
      commonDispatch({ type: 'SET_SIDEBAR_COLLAPSED', payload: value });
    } else {
      setCollapsed(value);
    }
  };

  // const scroll = () => {
  //     if (navFixedLayout && headerFixedLayout === false) {
  //         const main = document.querySelector('.pcoded-navbar');
  //         const el = document.querySelector('.pcoded-navbar.menupos-fixed');
  //         const scrollPosition = window.pageYOffset;
  //         if (scrollPosition > 60) {
  //             el.style.position = 'fixed';
  //             el.style.transition = 'none';
  //             el.style.marginTop = '0';
  //         } else {
  //             main.style.position = 'absolute';
  //             main.style.marginTop = '56px';
  //         }
  //     } else {
  //         document.querySelector('.pcoded-navbar').removeAttribute('style');
  //     }
  // };

  let navClass = [
    'pcoded-navbar'
    //layoutType
  ];

  if (subLayout !== null && subLayout !== '' && subLayout !== 'layout-6' && subLayout !== 'layout-8' && subLayout !== 'horizontal-2') {
    navClass = [...navClass, subLayout];
  } else {
    navClass = [
      ...navClass,
      layoutType,
      navBackColor,
      navBrandColor,
      'drp-icon-' + navDropdownIcon,
      'menu-item-icon-' + navListIcon,
      navActiveListColor,
      navListTitleColor
    ];

    if (navBackImage) {
      navClass = [...navClass, navBackImage];
    }

    if (navIconColor) {
      navClass = [...navClass, 'icon-colored'];
    }

    if (!navFixedLayout && layout !== 'horizontal') {
      navClass = [...navClass, 'menupos-static'];
    }

    if (navListTitleHide) {
      navClass = [...navClass, 'caption-hide'];
    }
  }

  if (layout === 'horizontal') {
    navClass = [...navClass, 'theme-horizontal'];
  }

  if (windowSize.width < 992 && !collapseMenu) {
    navClass = [...navClass, 'mob-open'];
  } else if (collapseMenu) {
    navClass = [...navClass, 'navbar-collapsed'];
  }

  if (subLayout === 'layout-6') {
    document.body.classList.add('layout-6');
    document.body.style.backgroundImage = layout6Background;
    document.body.style.backgroundSize = layout6BackSize;
  }

  if (subLayout === 'layout-8') {
    document.body.classList.add('layout-8');
  }

  if (layoutType === 'dark') {
    document.body.classList.add('datta-dark');
  } else {
    document.body.classList.remove('datta-dark');
  }

  if (rtlLayout) {
    document.body.classList.add('datta-rtl');
  } else {
    document.body.classList.remove('datta-rtl');
  }

  if (boxLayout) {
    document.body.classList.add('container');
    document.body.classList.add('box-layout');
  } else {
    document.body.classList.remove('container');
    document.body.classList.remove('box-layout');
  }

  let navStyle;

  let navBarClass = ['navbar-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBarClass = [...navBarClass, 'container'];
  }

  const [customMenuItems, setCustomMenuItems] = useState([]);

  const { menuItems } = useMenuItems();

  useEffect(() => {
    setCustomMenuItems(menuItems);
  }, [menuItems]);

  useEffect(() => {
    if (menuItems.length === 0) {
      document.body.classList.add('no-sidemenu');
    } else {
      document.body.classList.remove('no-sidemenu');
    }
    return () => document.body.classList.remove('no-sidemenu');
  }, [menuItems.length]);

  let navContent = (
    <div className={navBarClass.join(' ')}>
      <NavLogo />
      <NavContent navigation={customMenuItems} />
    </div>
  );
  if (windowSize.width < 992) {
    navContent = (
      <div className="navbar-wrapper">
        <NavLogo />
        <NavContent navigation={customMenuItems} />
      </div>
    );
  }

  if (isTrail == true) navClass = navClass.concat(['custom-top-51 billing_notify']);

  if (commonState.lockStatus === 1) {
    navClass = navClass.concat(['default-wid']);
  } else if (commonState.lockStatus === 0) {
    navClass = navClass.filter((itemClass) => itemClass !== 'default-wid');
  }

  const isActive = (path) => location.pathname === path;

  const { payloadState, payloadDispatch } = usePayloadContext()
  const payloadStateRef = useRef(JSON.stringify(payloadState?.dateRange) || "[]")

  useEffect(() => {
    if(JSON.stringify(payloadState?.dateRange) != payloadStateRef.current) {
      payloadStateRef.current = JSON.stringify(payloadState?.dateRange)
    }
  }, [payloadState?.dateRange])
  

  const doNavigateTo = useCallback((pathName) => {
    // Close sidebar on mobile/tablet when navigating
    if (windowSize.width < 992 && !commonState.sidebarCollapsed) {
      commonDispatch({ type: 'SET_SIDEBAR_COLLAPSED', payload: true });
    }
    // const getNewDateRange =  getNewPayloadDateRange(pathName)
    // if(payloadStateRef.current != JSON.stringify(getNewDateRange)) {
    //   payloadDispatch({ type: 'UPDATE_DATE_RANGE', payload: getNewDateRange })
    //   payloadStateRef.current = JSON.stringify(getNewDateRange)
    // }
    if(pathName === '/amazon/marketing-stream' || pathName === '/amazon/targeting' || pathName == '/summary/flipkart' || pathName === '/summary/instamart' || pathName === '/summary/myntra' || pathName === '/summary/blinkit' || pathName === '/summary/zepto' || pathName === '/summary/bigbasket' || pathName === '/amazon/search-query-performance') {
      window.location.assign(pathName)
    } else {
      history.push(pathName)
    }
  }, [windowSize.width, commonState.sidebarCollapsed, commonDispatch, history])

  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (!sidebarCollapsed) {
      setShowOverlay(true);
    } else {
      // Wait for the sidebar transition to finish before hiding overlay
      const timeout = setTimeout(() => setShowOverlay(false), 1000); // 1000ms = transitionDuration
      return () => clearTimeout(timeout);
    }
  }, [sidebarCollapsed]);
  
  // Close sidebar when clicking outside on mobile/tablet
  useEffect(() => {
    if (isMobileOrTablet && !sidebarCollapsed) {
      const handleClickOutside = (event) => {
        const sidebar = document.querySelector('.new-theme-sidemenu');
        const toggleButton = document.querySelector('.mobile-sidebar-toggle');
        if (sidebar && !sidebar.contains(event.target) && !toggleButton?.contains(event.target)) {
          handleSidebarToggle(true);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isMobileOrTablet, sidebarCollapsed]);

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
    {/* {process.env.REACT_APP_ADMIN_ACCESS_EMAIL.indexOf(commonState?.userInfo?.email) > -1  ?  */}
    <div className={`new-theme-sidemenu ${showOverlay ? 'standing_sidmenu' : 'collapsed_sidemenu'} ${isMobileOrTablet ? 'mobile-sidebar' : ''}`}>
    <Sidebar 
      collapsed={sidebarCollapsed} 
      backgroundColor={theme[0].theme === 'DARK' ? "#333b45" : "#130c42"} 
      width='370px' 
      transitionDuration={1000}
      style={isMobileOrTablet ? {
        position: 'fixed',
        zIndex: 1000,
        height: '100vh',
        left: sidebarCollapsed ? '-370px' : '0',
      } : {}}
    >
      <div className='main-logo-container'>
        {sidebarCollapsed ? <HectorLogo /> : <HectorLogoFull width="150" />}
      </div>
      <Menu
      closeOnClick
        menuItemStyles={{
        button: ({ active }) => {
          const baseStyle = {
            color: active
              ? '#fff'
              : '#fff',
            backgroundColor: active
              ? theme[0].theme === 'DARK' ? '#1f2934' : '#342785'
              : '',
            margin: '6px 16px',
            borderRadius: '6px',
            height: "auto",
            padding: '5px 8px 5px 7px',
            fontSize: "10px",
            lineHeight: "normal",
          };
          return {
            ...baseStyle,
            "&:hover": {
              backgroundColor: theme[0].theme === 'DARK' ? '#1f2934' : '#342785',
              color: '#fff',
            },
          };
        }
      }}>
      {menuItems.map((submenu, index) => (
        <SubMenu 
        active={submenu.items.some((item) => isActive(item.path))}
        key={`${index}--${String(submenu.title).replaceAll(' ', '-').toLowerCase()}`} 
        label={submenu.title} 
        icon={submenu.icon}
        onClick={() => {
          setActiveSubmenu(activeSubmenu === submenu.title ? null : submenu.title)
          // setTimeout(() => {
          //   const submenuContent = document.querySelector('[data-testid="ps-submenu-content-test-id"]');
          //   console.log("submenuContent", submenuContent)
          //   if (submenuContent && submenuContent.scrollHeight) {
          //     submenuContent.scrollTop = submenuContent.scrollHeight;
          //   }  
          // }, 500)
        }}
        className={`${submenu.title.toLowerCase()}-menu-items`}
        >
          {submenu.items.map((item, subIndex) => {
            if(item?.items?.length > 0) {
              return (
                <SubMenu 
                active={item?.items.some((item) => isActive(item.path))}
                key={`${index}--${String(item.title).replaceAll(' ', '-').toLowerCase()}`} 
                label={
                  <div className='beta-icon-container'>
                    <span>{item.title}</span>
                    {item.isBeta && <img src={betaIconPng} alt="Beta" style={{width: '33px', height: '17px'}} />}
                  </div>
                } 
                icon={item.icon}
                onClick={() => {
                  setActiveSubmenu(activeSubmenu === item.title ? null : item.title)
                  // setTimeout(() => {
                  //   const submenuContent = document.querySelector('[data-testid="ps-submenu-content-test-id"]');
                  //   console.log("submenuContent", submenuContent)
                  //   if (submenuContent && submenuContent.scrollHeight) {
                  //     submenuContent.scrollTop = submenuContent.scrollHeight;
                  //   }  
                  // }, 500)
                }}
                className='second-submenu'
                >
                  {item?.items?.map((childItem, subIndex) => {
                    return (
                        <MenuItem 
                        active={isActive(item.path)}
                        onClick={() => {
                          doNavigateTo(childItem.path);
                        }} 
                        key={`${subIndex}--${childItem.path}`} icon={childItem.icon}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <span>{childItem.label}</span>
                            {childItem.isBeta && <img src={betaIconPng} alt="Beta" style={{width: '33px', height: '17px'}} />}
                          </div>
                        </MenuItem>
                    )
                  })}
                </SubMenu>
              )
            }
            return (
                <MenuItem 
                active={isActive(item.path)}
                onClick={() => {
                  doNavigateTo(item.path)
                }} 
                key={`${subIndex}--${item.path}`} icon={item.icon}
                > 
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <span>{item.label}</span>
                    {item.isBeta && <img src={betaIconPng} alt="Beta" style={{width: '33px', height: '17px'}} />}
                  </div>
                </MenuItem>
            )
          })}
        </SubMenu>
      ))}

            <div className="main-logo-container toggle-btn">
              {sidebarCollapsed ? (
                <LockIcon onClick={() => handleSidebarToggle(false)} />
              ) : (
                <UnlockIcon onClick={() => handleSidebarToggle(true)} />
              )}
            </div>
          </Menu>
        </Sidebar>
        {/* Overlay */}
        {!sidebarCollapsed && isMobileOrTablet && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 999,
              cursor: 'pointer',
              opacity: sidebarCollapsed ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out'
            }}
            onClick={() => handleSidebarToggle(true)}
          ></div>
        )}
      </div>
      {/* //   :
  //   <nav className={navClass.join(' ')} style={{...navStyle}}>
  //   {navContent}
  // </nav>
  // } */}
    </React.Fragment>
  );
};

export default Navigation;
